import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import { COLORS } from './storeManagementConstants';
import { formatLastRefresh } from './storeManagementParts';

export function StoreManagementHeader({
  totalKitchens,
  lastRefreshAt,
  loading,
  onRefreshList,
}) {
  return (
    <Box
      sx={{
        px: { xs: 2.5, sm: 4 },
        pt: { xs: 3, sm: 3.5 },
        pb: 2.5,
        bgcolor: COLORS.white,
        borderBottom: `1px solid ${COLORS.border}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: '14px',
            bgcolor: COLORS.accentOrange,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            boxShadow: `0 4px 14px rgba(255, 123, 41, 0.38)`,
          }}
        >
          <StorefrontOutlinedIcon sx={{ fontSize: 24, color: COLORS.white }} />
        </Box>
        <Box>
          <Typography
            sx={{
              fontFamily: 'Inter Bold, sans-serif',
              fontSize: { xs: 20, sm: 24 },
              fontWeight: 700,
              color: COLORS.ink,
              letterSpacing: '-0.02em',
              lineHeight: 1.2,
            }}
          >
            Store Management
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Inter Regular, sans-serif',
              fontSize: 13,
              color: COLORS.muted,
              mt: 0.3,
            }}
          >
            Manage and monitor all registered kitchen stores
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.75 }}>
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1,
            bgcolor: COLORS.accentOrange,
            borderRadius: '12px',
            px: 2,
            py: 0.75,
            boxShadow: `0 3px 10px rgba(255, 123, 41, 0.30)`,
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Inter Regular, sans-serif',
              fontSize: 12,
              color: 'rgba(255,255,255,0.85)',
              lineHeight: 1,
            }}
          >
            Total stores
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Inter Bold, sans-serif',
              fontSize: 18,
              fontWeight: 800,
              color: COLORS.white,
              lineHeight: 1,
            }}
          >
            {totalKitchens}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Typography
            component="span"
            sx={{
              fontFamily: 'Inter Regular, sans-serif',
              fontSize: 11,
              color: COLORS.muted,
            }}
          >
            Last refresh: {formatLastRefresh(lastRefreshAt)}
          </Typography>
          <Tooltip title="Refresh list" placement="top">
            <span>
              <IconButton
                type="button"
                size="small"
                aria-label="Refresh store list"
                disabled={loading}
                onClick={onRefreshList}
                sx={{
                  p: 0.4,
                  color: COLORS.ink,
                  transition: 'all 0.2s',
                  '&:hover': {
                    bgcolor: 'rgba(255, 123, 41, 0.10)',
                    color: COLORS.accentOrange,
                  },
                  '&.Mui-disabled': { color: COLORS.muted },
                }}
              >
                <RefreshOutlinedIcon sx={{ fontSize: 16 }} />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      </Box>
    </Box>
  );
}
